import { HttpService } from '@/infra/http'
import type { TTipoEmpreendimento } from '@/types/empreendimento'
import type { TSituacaoEntregaEmprendimento } from '@/utils/key-map'

export type TGetEmpreendimentosResponse = Array<{
  idExterno: number
  id: string
  nome: string
  imagem: string
  bairro: string
  situacaoEntrega?: TSituacaoEntregaEmprendimento
  tipoDeEmpreendimento: TTipoEmpreendimento
  metragem: string
  quartos?: string
  empreendimentoFuturo: boolean
}>

export const FaixaInvestimentoEnum = {
  Ate300Mil: 'Ate300Mil',
  De300Ate500Mil: 'De300Ate500Mil',
  De500Ate700Mil: 'De500Ate700Mil',
  De700MilAte1Milhao: 'De700MilAte1Milhao',
  De1MilhaoAte1_5Milhao: 'De1MilhaoAte1_5Milhao',
  De1_5MilhaoAte2Milhoes: 'De1_5MilhaoAte2Milhoes',
  De2MilhoesAte3Milhoes: 'De2MilhoesAte3Milhoes',
  AcimaDe3Milhoes: 'AcimaDe3Milhoes',
} as const
export type TFaixaInvestimento = (typeof FaixaInvestimentoEnum)[keyof typeof FaixaInvestimentoEnum]

export type TGetEmpreendimentosFilters<TFaixa = TFaixaInvestimento> = {
  situacao?: TSituacaoEntregaEmprendimento
  tipoDeEmpreendimento?: TTipoEmpreendimento
  faixaDeInvestimento?: TFaixa
}

export class GetEmpreendimentosService extends HttpService {
  execute = async (filtros: TGetEmpreendimentosFilters) => {
    return this.http.get<TGetEmpreendimentosResponse>(`api/v2/Empreendimento`, { params: filtros })
  }
}
